// ** Reducers Imports
import layout from './layout'
import navbar from './navbar'
import auth from './authentication'
import companies from '../views/pages/apps/companies/store'
import taxMailBox from '../views/pages/apps/taxMailbox/apps/TaxMailbox/store'
import taxNotifications from '../views/pages/apps/taxMailbox/apps/TMNotifications/store'
import taxNotificationsDocs from '../views/pages/apps/taxMailbox/apps/TMNotificationDocs/store'
import prevCompanies from '../views/pages/apps/invoice/companies/store'
import companiesStatus from '../views/pages/apps/companies/status/store/index'
import allCensus from '../views/pages/apps/catalogs/companyCensus/store'
import companyCensus from '../views/pages/apps/catalogs/census/store'
import censusStatus from '../views/pages/apps/catalogs/statusCensus/store'
import address from "../views/pages/apps/catalogs/address/store"
import viability from "../views/pages/apps/catalogs/address/viability/store"
import statusAdress from "../views/pages/apps/catalogs/address/catalogStatus/index"
import partners from "../views/pages/apps/catalogs/partners/store"
import giros from "../views/pages/apps/catalogs/giros/store"
import activities from "../views/pages/apps/catalogs/business-activities/store"
import users from "../views/pages/apps/catalogs/users/store"
import roles from "../views/pages/apps/catalogs/roles/store"
import abilities from "../views/pages/apps/catalogs/abilities/store"
import bankAccounts from "../views/pages/apps/catalogs/bankAccounts/store"
import bankTransactions from "../views/pages/apps/badge/apps/accounts/transactions/store"
import bankActivities from "../views/pages/apps/badge/apps/transfers/store"
import bankTypes from "../views/pages/apps/catalogs/bankTypes/store"
import intermediaries from "../views/pages/apps/register/management/intermediaries/store"
import intermediaryIncome from "../views/pages/apps/register/management/intermediaries/apps/income/store"
import credit from "../views/pages/apps/register/management/intermediaries/apps/credits/store"
import devolution from "../views/pages/apps/register/resume/returns/store"
import checks from '../views/pages/apps/gestion/checks/store'
import checkbooks from "../views/pages/apps/gestion/checkbooks/store"
import bankChecks from "../views/pages/apps/gestion/checks/bankChecks/store"
import cash from "../views/pages/apps/cash/activities/store/index"
import expenses from "../views/pages/apps/register/management/intermediaries/apps/expenses/store"
import cashDeposit from "../views/pages/apps/cash/deposit/store/index"
import invoices from "../views/pages/apps/invoice/invoices/store/index"
import foliosPrevios from "../views/pages/apps/invoice/invoices/foliosPrevios/store/index"
import commissions from "../views/pages/apps/register/management/intermediaries/apps/commissions/store"
import clients from "../views/pages/apps/invoice/clients/store/index"
import todo from "../views/pages/apps/todo/store/index"
import checksRegister from "../views/pages/apps/register/management/checks/store"
import cashExpenses from '../views/pages/apps/cash/expenses/store/index'
import locations from '../views/pages/apps/cash/expenses/locations/store'
import transferenceIntermediary from '../views/pages/apps/register/management/intermediaries/apps/transfer/store'
import cashCommission from "../views/pages/apps/cash/comissions/store"
import concept from "../views/pages/apps/concept/store"
import catalogUsers from "../views/pages/apps/cash/user/store"
import cashBox from "../views/pages/apps/box/store"
import concepts from '../views/pages/apps/cash/box/concepts/store'
import permissionsCashBox from '../views/pages/apps/cash/box/permissionsToAssign/store'
import expensesPending from "../views/pages/apps/cash/expenses/pendingExpenses/store"
import cashCredit from '../views/pages/apps/cash/credits/store'
import blocks from '../views/pages/apps/cash/comissions/blocks/store'
import bodyBlocks from '../views/pages/apps/cash/comissions/blocks/bodyBlock/store'
import expensesBlock from '../views/pages/apps/cash/expenses/Blocks/store'
import transactionsLinked from '../views/pages/apps/register/management/cfdi/store'
import categories from '../views/pages/apps/catalogs/services/category/store'
import services from '../views/pages/apps/catalogs/services/services/store'
import paymentServices from '../views/pages/apps/services/store'
import legalPersons from '../views/pages/apps/catalogs/services/legalPerson/store'
import notary from '../views/pages/apps/catalogs/notary/store'
import faculty from '../views/pages/apps/catalogs/faculty/store'
import allProcessTracking from '../views/pages/apps/processTracking/rfc/store'
import branchOffices from '../views/pages/apps/catalogs/bankAccounts/branchOffice/store'
import emails from '../views/pages/apps/emails/store'
import codes from '../views/pages/apps/emails/codes/store'
import taxRegimes from '../views/pages/apps/catalogs/taxRegime/store'

const rootReducer = { navbar, layout, auth, companies, prevCompanies, companiesStatus, allCensus, companyCensus, censusStatus, address, viability, partners, giros, activities, users, roles, abilities, bankAccounts, bankTransactions, bankActivities, bankTypes, intermediaries, credit, devolution, checks, checkbooks, bankChecks, cash, expenses, cashDeposit, commissions, invoices, foliosPrevios, clients, todo, checksRegister, cashExpenses, locations, transferenceIntermediary, cashCommission, intermediaryIncome, concept, catalogUsers, cashBox, concepts, permissionsCashBox, expensesPending, cashCredit, blocks, bodyBlocks, expensesBlock, transactionsLinked, categories, services, paymentServices, legalPersons, statusAdress, notary, faculty, allProcessTracking, branchOffices, emails, codes, taxMailBox, taxNotifications, taxNotificationsDocs, taxRegimes }

export default rootReducer
